export default __webpack_public_path__ + "static/TourismImprovementDistrictTID-9a44768471973ffc18054390e9f376cb.jpg";